// @ts-nocheck
import parseNumber from "@toolkit/Framework/Common/Utilities/parseNumber";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const contentWidth = 1410;
const spacing = {
    side: [pxToRem(20), pxToRem(30), pxToRem(45), pxToRem(45), pxToRem(60)],
    content: [pxToRem(25), pxToRem(30), pxToRem(45), pxToRem(60), pxToRem(60)],
    smallContent: [pxToRem(20), pxToRem(25), pxToRem(30), pxToRem(35), pxToRem(40)],
    narrowContent: [pxToRem(25), pxToRem(30), pxToRem(40), pxToRem(40), pxToRem(50)],
};
const largestSideSpacing = spacing.side.filter(x => x).pop() as any;
const siteWidth = contentWidth + (parseNumber(largestSideSpacing) ?? 0) * 2;
export const breakpointsValues = [0, 600, 900, 1200, siteWidth];
const maxWidth = breakpointsValues[breakpointsValues.length - 1];

const breakpoints: Styleguide["breakpoints"] = {
    values: breakpointsValues,
    maxWidths: breakpointsValues.map(x => maxWidth),
};

export default breakpoints;
